import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Dashboard from '@/views/Dashboard.vue'
import Login from '@/views/auth/Login.vue'
import { TokenService } from '@/services/storage.service'
import ClientRoutes from './clients'
import UserRoutes from './users'
import store from '@/store'
import Default from '../layouts/Default'
import Auth from '../layouts/Auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/auth',
      name: 'auth',
      component: Auth,
      children: [
        {
          path: 'login',
          name: 'login',
          component: Login,
          meta: {
            public: true, // Allow access to even if not logged in
            onlyWhenLoggedOut: true
          }
        }
      ]
    },
    {
      path: '/',
      name: 'admin',
      component: Default,
      beforeRouteUpdate: () => {
        store.commit('loaded')
      },
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: Dashboard
        },
        ...ClientRoutes,
        ...UserRoutes
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  // eslint-disable-next-line no-undef
  jQuery('.modal').modal('hide')
  store.commit('loading')
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken()
  if (!isPublic && !loggedIn) {
    return next({
      name: 'login',
      query: { redirect: to.fullPath }
      // Store the full path to redirect the user to after login
    })
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/')
  }

  next()
})

router.afterEach((to, from) => {
  // eslint-disable-next-line no-undef
  jQuery('#page-container').removeClass('sidebar-o-xs')
  store.commit('loaded')
})

export default router
